import { LoanPropertyFileType } from './LoanPropertyFileType';

export const LoanPropertyFileTypeOptions = [
    {
        id: LoanPropertyFileType.Budget,
        name: 'Budget',
    },
    {
        id: LoanPropertyFileType.SpecSheet,
        name: 'Spec. Sheet',
    },
    {
        id: LoanPropertyFileType.Plans,
        name: 'Plans',
    },
    {
        id: LoanPropertyFileType.Survey,
        name: 'Survey',
    },
    {
        id: LoanPropertyFileType.GCResume,
        name: 'GC Resume',
    },
    {
        id: LoanPropertyFileType.PresaleContract,
        name: 'Presale Contract',
    },
    {
        id: LoanPropertyFileType.CapitalExpenditures,
        name: 'Capital Expenditures',
    },
    {
        id: LoanPropertyFileType.PurchaseContract,
        name: 'Purchase Contract',
    },
    {
        id: LoanPropertyFileType.Appraisal,
        name: 'Appraisal',
    },
    {
        id: LoanPropertyFileType.Other,
        name: 'Other',
    },
];
